module.exports = __webpack_public_path__ + "static/media/brand3.4e71f7e6.png";